// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_web__Browser from "./browser.js";
import * as Mapre_web__Web_accounts_controller from "./web_accounts_controller.js";
import * as Mapre_web__Web_attachments_controller from "./web_attachments_controller.js";
import * as Mapre_web__Web_attachments_model from "./web_attachments_model.js";
import * as Mapre_web__Web_build_controller from "./web_build_controller.js";
import * as Mapre_web__Web_checkpoint_controller from "./web_checkpoint_controller.js";
import * as Mapre_web__Web_checkpoint_model from "./web_checkpoint_model.js";
import * as Mapre_web__Web_codec from "./web_codec.js";
import * as Mapre_web__Web_comments_controller from "./web_comments_controller.js";
import * as Mapre_web__Web_connection from "./web_connection.js";
import * as Mapre_web__Web_deadline from "./web_deadline.js";
import * as Mapre_web__Web_environment_controller from "./web_environment_controller.js";
import * as Mapre_web__Web_graph_controller from "./web_graph_controller.js";
import * as Mapre_web__Web_invitation_controller from "./web_invitation_controller.js";
import * as Mapre_web__Web_message_controller from "./web_message_controller.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Mapre_web__Web_permissions_controller from "./web_permissions_controller.js";
import * as Mapre_web__Web_personal_tokens_controller from "./web_personal_tokens_controller.js";
import * as Mapre_web__Web_project_controller from "./web_project_controller.js";
import * as Mapre_web__Web_publication_controller from "./web_publication_controller.js";
import * as Mapre_web__Web_pulls_controller from "./web_pulls_controller.js";
import * as Mapre_web__Web_session_tree from "./web_session_tree.js";
import * as Mapre_web__Web_session_usage_controller from "./web_session_usage_controller.js";
import * as Mapre_web__Web_settings_controller from "./web_settings_controller.js";
import * as Mapre_web__Web_types from "./web_types.js";
import * as Mapre_web__Web_usage_controller from "./web_usage_controller.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__Float from "melange/float.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";

function stop(t) {
  Stdlib__Option.iter(Mapre_web__Web_attachments_controller.cancel, t.attachments);
  Stdlib__Option.iter(Mapre_web__Web_invitation_controller.cancel, t.invitations);
  Stdlib__Option.iter(Mapre_web__Web_checkpoint_controller.cancel, t.checkpoint);
  Stdlib__Option.iter(Mapre_web__Web_comments_controller.cancel, t.comments);
  Stdlib__Option.iter(Mapre_web__Web_pulls_controller.cancel, t.pulls);
  Stdlib__Option.iter(Mapre_web__Web_project_controller.cancel, t.project_setup);
  Stdlib__Option.iter(Mapre_web__Web_environment_controller.cancel, t.environment);
  Stdlib__Option.iter(Mapre_web__Web_build_controller.cancel, t.builds);
  Stdlib__Option.iter(Mapre_web__Web_graph_controller.cancel, t.graph);
  Stdlib__Option.iter(Mapre_web__Web_settings_controller.cancel, t.settings);
  Stdlib__Option.iter(Mapre_web__Web_usage_controller.cancel, t.usage);
  Stdlib__Option.iter(Mapre_web__Web_session_usage_controller.cancel, t.session_usage);
  Stdlib__Option.iter(Mapre_web__Web_personal_tokens_controller.cancel, t.personal_tokens);
  Stdlib__Option.iter(Mapre_web__Web_accounts_controller.cancel, t.accounts);
  Stdlib__Option.iter(Mapre_web__Web_permissions_controller.cancel, t.permissions);
  Stdlib__Option.iter(Mapre_web__Web_message_controller.cancel, t.messages);
  Stdlib__Option.iter(Mapre_web__Web_publication_controller.cancel, t.publication);
  t.generation = t.generation + 1 | 0;
  Mapre_web__Browser.abort(t.controller);
  t.controller = new AbortController();
  Stdlib__Option.iter(Mapre_web__Browser.cancel, t.poll);
  t.poll = undefined;
  t.control_notice = undefined;
  Stdlib__Option.iter(Mapre_web__Web_connection.dispose, t.stream);
  t.stream = undefined;
}

function dispose(t) {
  stop(t);
  t.stopped = true;
}

function lock(t, reason, notice) {
  stop(t);
  Curry._1(t.emit, {
    TAG: /* Lock */ 23,
    _0: reason,
    _1: notice
  });
}

function failure(t, code) {
  if (/* tag */ typeof code !== "object" && typeof code !== "function") {
    switch (code) {
      case /* Unauthorized */ 0 :
        return lock(t, /* Login_required */ 0, "Sign in required");
      case /* Forbidden */ 1 :
        return Curry._1(t.emit, {
          TAG: /* Notice */ 21,
          _0: "Permission denied. Your role does not allow this action."
        });
      case /* Invalid_response */ 2 :
        return Curry._1(t.emit, {
          TAG: /* Notice */ 21,
          _0: "Invalid server response."
        });
    }
  } else {
    if (code.TAG === /* Missing */ 0) {
      return lock(t, /* Access_removed */ 1, "Access removed");
    }
    const code$1 = code._0;
    switch (code$1) {
      case "github_branch_not_found" :
        return Curry._1(t.emit, {
          TAG: /* Notice */ 21,
          _0: "That branch was not found. Check its name and try again."
        });
      case "invalid_base_branch" :
        return Curry._1(t.emit, {
          TAG: /* Notice */ 21,
          _0: "Enter a valid base branch name."
        });
      default:
        return Curry._1(t.emit, {
          TAG: /* Notice */ 21,
          _0: code$1
        });
    }
  }
}

function request(t, body, on_errorOpt, path, consume) {
  const on_error = on_errorOpt !== undefined ? on_errorOpt : (function (param) {
      return failure(t, param);
    });
  const generation = t.generation;
  Mapre_web__Browser.request(t.controller, undefined, body, path).then(function (result) {
    if (!t.stopped && generation === t.generation) {
      if (result.TAG === /* Ok */ 0) {
        try {
          Curry._1(consume, result._0);
        }
        catch (raw_exn){
          const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
          if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
            Curry._1(on_error, /* Invalid_response */ 2);
          } else {
            throw exn;
          }
        }
      } else {
        Curry._1(on_error, result._0);
      }
    }
    return Promise.resolve();
  });
}

function session_path(w, s) {
  return "/api/workspaces/" + w + ("/sessions/" + s);
}

function project_path(w, p) {
  return "/api/workspaces/" + w + ("/projects/" + p);
}

function subscriptions(t, more) {
  const model = Curry._1(t.model, undefined);
  const w = Mapre_web__Web_types.workspace(model.route);
  if (w === undefined) {
    return;
  }
  Curry._1(t.emit, {
    TAG: /* Subscriptions_loading */ 7,
    _0: true
  });
  const suffix = more ? Stdlib__Option.fold("", (function (cursor) {
      return "?after_id=" + cursor;
    }), model.subscription_cursor) : "";
  request(t, undefined, (function (error) {
    Curry._1(t.emit, {
      TAG: /* Subscriptions_loading */ 7,
      _0: false
    });
    failure(t, error);
  }), "/api/workspaces/" + w + ("/connections" + suffix), (function (json) {
    Curry._1(t.emit, {
      TAG: /* Subscriptions */ 5,
      _0: Mapre_web__Web_codec.subscriptions(json),
      _1: Js__Js_json.decodeString(Mapre_wire__Json.get(json, "next_cursor")),
      _2: more
    });
  }));
}

function list_sessions(t, w, p, more) {
  const model = Curry._1(t.model, undefined);
  const suffix = more ? Stdlib__Option.fold("", (function (cursor) {
      return "?after_id=" + cursor;
    }), model.next_session) : "";
  const focus = Stdlib__Option.fold("", (function (id) {
    return (
      suffix === "" ? "?" : "&"
    ) + ("focus_id=" + id);
  }), Mapre_web__Web_types.session(model.route));
  request(t, undefined, undefined, project_path(w, p) + ("/sessions" + (suffix + focus)), (function (json) {
    const incoming = Mapre_web__Web_codec.sessions(json);
    const context = Stdlib__Array.to_list(Stdlib__Array.map(Mapre_web__Web_codec.session, Mapre_wire__Json.array(json, "context")));
    const sessions = Mapre_web__Web_session_tree.merge(more ? Curry._1(t.model, undefined).sessions : /* [] */ 0, Stdlib.$at(incoming, context));
    const cursor = Js__Js_json.decodeString(Mapre_wire__Json.get(json, "next_cursor"));
    Curry._1(t.emit, {
      TAG: /* Sessions */ 3,
      _0: sessions,
      _1: cursor
    });
  }));
}

function authorize(t, w, s, generation, param) {
  return Mapre_web__Browser.request(t.controller, undefined, undefined, session_path(w, s)).then(function (result) {
    const allowed = !t.stopped && generation === t.generation;
    let tmp;
    if (allowed) {
      if (result.TAG === /* Ok */ 0) {
        try {
          const row = Mapre_wire__Json.get(result._0, "session");
          if (Caml_obj.caml_notequal(Mapre_wire__Json.string(row, "project_id"), Mapre_web__Web_types.project(Curry._1(t.model, undefined).route))) {
            lock(t, /* Access_removed */ 1, "Access removed");
            tmp = false;
          } else {
            Curry._1(t.emit, {
              TAG: /* Selected */ 8,
              _0: Mapre_web__Web_codec.session(row)
            });
            tmp = true;
          }
        }
        catch (raw_exn){
          const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
          if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
            Curry._1(t.emit, {
              TAG: /* Notice */ 21,
              _0: "Invalid server response."
            });
            tmp = false;
          } else {
            throw exn;
          }
        }
      } else {
        failure(t, result._0);
        tmp = false;
      }
    } else {
      tmp = false;
    }
    return Promise.resolve(tmp);
  });
}

function poll(t, w, s, generation) {
  t.poll = setTimeout((function (param) {
    if (!t.stopped && generation === t.generation) {
      Stdlib__Option.iter(Mapre_web__Web_comments_controller.refresh, t.comments);
      return poll(t, w, s, generation);
    }
    
  }), 5000);
}

function recent_page(json) {
  const cursor = Mapre_wire__Json.integer(json, "next_cursor");
  let before;
  if (Caml_obj.caml_equal(Mapre_wire__Json.get(json, "before_seq"), null)) {
    before = undefined;
  } else {
    const value = Mapre_wire__Json.integer(json, "before_seq");
    if (value < 1) {
      throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
          MEL_EXN_ID: Mapre_wire__Json.Invalid,
          _1: "invalid_history_cursor"
        });
    }
    before = value;
  }
  const value$1 = Js__Js_json.decodeBoolean(Mapre_wire__Json.get(json, "has_more"));
  let more;
  if (value$1 !== undefined) {
    more = value$1;
  } else {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_history_page"
      });
  }
  if (cursor < 0 || more && before === undefined) {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_history_page"
      });
  }
  return [
    cursor,
    before,
    more,
    Mapre_web__Web_codec.events(json)
  ];
}

function navigate(t, pushOpt, route) {
  const push = pushOpt !== undefined ? pushOpt : true;
  stop(t);
  if (push) {
    Mapre_web__Browser.push(Mapre_web__Web_types.path(route));
  }
  Curry._1(t.emit, {
    TAG: /* Navigate */ 0,
    _0: route
  });
  request(t, undefined, undefined, "/auth/config", (function (json) {
    const value = Js__Js_json.decodeBoolean(Mapre_wire__Json.get(json, "github"));
    let enabled;
    if (value !== undefined) {
      enabled = value;
    } else {
      throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
          MEL_EXN_ID: Mapre_wire__Json.Invalid,
          _1: "invalid_auth_configuration"
        });
    }
    Curry._1(t.emit, {
      TAG: /* Auth_config */ 26,
      _0: enabled
    });
    request(t, undefined, undefined, "/api/workspaces", (function (json) {
      const workspaces = Mapre_web__Web_codec.workspaces(json);
      Curry._1(t.emit, {
        TAG: /* Workspaces */ 1,
        _0: workspaces
      });
      request(t, undefined, undefined, "/auth/me", (function (json) {
        Curry._1(t.emit, {
          TAG: /* Signed_in */ 27,
          _0: Mapre_wire__Json.string(Mapre_wire__Json.get(json, "user"), "login")
        });
        if (/* tag */ typeof route !== "object" && typeof route !== "function") {
          return;
        }
        if (route.TAG !== /* Invitation */ 0) {
          return;
        }
        const token = route._0;
        Stdlib__Option.iter((function (c) {
          Mapre_web__Web_invitation_controller.dispatch(c, {
            TAG: /* Receive */ 1,
            _0: token
          });
        }), t.invitations);
      }));
      const w = Mapre_web__Web_types.workspace(route);
      if (w === undefined) {
        return;
      }
      if (!Stdlib__List.exists((function (item) {
          return item.id === w;
        }), workspaces)) {
        return lock(t, /* Access_removed */ 1, "Access removed");
      }
      request(t, undefined, undefined, "/api/workspaces/" + w + "/projects", (function (json) {
        Curry._1(t.emit, {
          TAG: /* Projects */ 2,
          _0: Mapre_web__Web_codec.projects(json)
        });
      }));
      const p = Mapre_web__Web_types.project(route);
      if (p === undefined) {
        return;
      }
      list_sessions(t, w, p, false);
      Stdlib__Option.iter(Mapre_web__Web_build_controller.refresh_templates, t.builds);
      const s = Mapre_web__Web_types.session(route);
      if (s !== undefined) {
        return request(t, undefined, undefined, session_path(w, s) + "/events?mode=recent&limit=100", (function (json) {
          const match = recent_page(json);
          Curry._1(t.emit, {
            TAG: /* Recent */ 10,
            _0: match[0],
            _1: match[1],
            _2: match[2],
            _3: match[3]
          });
          const generation = t.generation;
          const stream = Mapre_web__Web_connection.create("/ws/workspaces/" + (w + ("/sessions/" + s)), (function (param) {
            return authorize(t, w, s, generation, undefined).then(function (allowed) {
              if (allowed) {
                return Mapre_web__Browser.request(t.controller, undefined, undefined, "/api/workspaces").then(function (result) {
                  const current = !t.stopped && generation === t.generation;
                  let tmp;
                  if (current) {
                    if (result.TAG === /* Ok */ 0) {
                      try {
                        const workspaces = Mapre_web__Web_codec.workspaces(result._0);
                        Curry._1(t.emit, {
                          TAG: /* Workspaces */ 1,
                          _0: workspaces
                        });
                        if (Stdlib__List.exists((function (item) {
                            return item.id === w;
                          }), workspaces)) {
                          Stdlib__Option.iter(Mapre_web__Web_message_controller.refresh, t.messages);
                          Stdlib__Option.iter(Mapre_web__Web_permissions_controller.refresh, t.permissions);
                          Stdlib__Option.iter(Mapre_web__Web_publication_controller.refresh, t.publication);
                          Stdlib__Option.iter(Mapre_web__Web_checkpoint_controller.refresh, t.checkpoint);
                          Stdlib__Option.iter(Mapre_web__Web_comments_controller.refresh, t.comments);
                          tmp = true;
                        } else {
                          lock(t, /* Access_removed */ 1, "Access removed");
                          tmp = false;
                        }
                      }
                      catch (raw_exn){
                        const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
                        if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
                          Curry._1(t.emit, {
                            TAG: /* Notice */ 21,
                            _0: "Invalid server response."
                          });
                          tmp = false;
                        } else {
                          throw exn;
                        }
                      }
                    } else {
                      failure(t, result._0);
                      tmp = false;
                    }
                  } else {
                    tmp = false;
                  }
                  return Promise.resolve(tmp);
                });
              } else {
                return Promise.resolve(false);
              }
            });
          }), (function (param) {
            return Curry._1(t.model, undefined).cursor;
          }), (function (cursor, events) {
            Curry._1(t.emit, {
              TAG: /* Events */ 9,
              _0: cursor,
              _1: events
            });
            if (Stdlib__List.exists((function (e) {
                return e.permission_update;
              }), events)) {
              Stdlib__Option.iter(Mapre_web__Web_permissions_controller.refresh, t.permissions);
            }
            if (Stdlib__List.exists((function (e) {
                return e.kind === "user_message" ? true : e.kind === "command_result";
              }), events)) {
              Stdlib__Option.iter(Mapre_web__Web_message_controller.refresh, t.messages);
              Stdlib__Option.iter(Mapre_web__Web_publication_controller.refresh, t.publication);
              Stdlib__Option.iter(Mapre_web__Web_checkpoint_controller.refresh, t.checkpoint);
              return Stdlib__Option.iter(Mapre_web__Web_comments_controller.refresh, t.comments);
            }
            
          }), (function (param, param$1, param$2) {
            const match = t.control_notice;
            const fresh = match !== undefined && match[0] === param ? param$1 > match[1] : true;
            if (fresh && !t.stopped && generation === t.generation) {
              t.control_notice = [
                param,
                param$1
              ];
              return Stdlib__List.iter((function (param) {
                switch (param) {
                  case /* Session */ 0 :
                    authorize(t, w, s, generation, undefined);
                    return;
                  case /* Commands */ 1 :
                    return Stdlib__Option.iter(Mapre_web__Web_message_controller.refresh, t.messages);
                  case /* Publication */ 2 :
                    return Stdlib__Option.iter(Mapre_web__Web_publication_controller.refresh, t.publication);
                  case /* Checkpoint */ 3 :
                    return Stdlib__Option.iter(Mapre_web__Web_checkpoint_controller.refresh, t.checkpoint);
                  case /* Comments */ 4 :
                    return Stdlib__Option.iter(Mapre_web__Web_comments_controller.refresh, t.comments);
                  case /* Permissions */ 5 :
                    return Stdlib__Option.iter(Mapre_web__Web_permissions_controller.refresh, t.permissions);
                }
              }), param$2);
            }
            
          }), (function (status) {
            Curry._1(t.emit, {
              TAG: /* Connection */ 22,
              _0: status
            });
          }), (function (param) {
            lock(t, /* Access_removed */ 1, "Access removed");
          }));
          t.stream = Caml_option.some(stream);
          poll(t, w, s, generation);
        }));
      }
      
    }));
  }));
}

function budget(text) {
  const value = Stdlib.float_of_string_opt(text);
  if (value !== undefined && Stdlib__Float.is_finite(value) && value > 0 && value <= 2147) {
    return Math.round(value * 1000000) | 0;
  }
  
}

function form_source(model, form) {
  const match = form.source;
  const match$1 = model.templates;
  if (match !== undefined) {
    return [
      match[0],
      Mapre_wire__Json.str(match[1])
    ];
  } else if (match$1) {
    return [
      match$1.hd.id,
      null
    ];
  } else {
    return;
  }
}

function session_action(t, action) {
  if (/* tag */ typeof action !== "object" && typeof action !== "function") {
    if (action !== /* Close_form */ 3) {
      return Curry._1(t.emit, action);
    }
    Stdlib__Option.iter((function (controller) {
      Mapre_web__Web_attachments_controller.cancel_target(controller, /* Initial */ 0);
    }), t.attachments);
    return Curry._1(t.emit, action);
  } else {
    switch (action.TAG) {
      case /* Permissions */ 42 :
        const action$1 = action._0;
        return Stdlib__Option.iter((function (permissions) {
          Mapre_web__Web_permissions_controller.dispatch(permissions, action$1);
        }), t.permissions);
      case /* Messages */ 43 :
        const action$2 = action._0;
        return Stdlib__Option.iter((function (messages) {
          Mapre_web__Web_message_controller.dispatch(messages, action$2);
        }), t.messages);
      case /* Attachments */ 44 :
        const action$3 = action._1;
        const target = action._0;
        return Stdlib__Option.iter((function (controller) {
          Mapre_web__Web_attachments_controller.dispatch(controller, target, action$3);
        }), t.attachments);
      case /* Publication */ 45 :
        const action$4 = action._0;
        return Stdlib__Option.iter((function (publication) {
          Mapre_web__Web_publication_controller.dispatch(publication, action$4);
        }), t.publication);
      case /* Checkpoint */ 46 :
        const action$5 = action._0;
        if (/* tag */ typeof action$5 !== "object" && typeof action$5 !== "function" && action$5 === /* Child */ 4) {
          const model = Curry._1(t.model, undefined);
          const match = model.route;
          const match$1 = Mapre_web__Web_checkpoint_model.child(model.checkpoint);
          if (/* tag */ typeof match !== "object" && typeof match !== "function" || !(match.TAG === /* Session */ 3 && match$1 !== undefined && Mapre_web__Web_model.can_create(model))) {
            return;
          } else {
            Curry._1(t.emit, {
              TAG: /* Open_child */ 16,
              _0: match$1,
              _1: match._2,
              _2: crypto.randomUUID()
            });
            return subscriptions(t, false);
          }
        }
        return Stdlib__Option.iter((function (controller) {
          Mapre_web__Web_checkpoint_controller.dispatch(controller, action$5);
        }), t.checkpoint);
      case /* Comments */ 47 :
        const action$6 = action._0;
        return Stdlib__Option.iter((function (comments) {
          Mapre_web__Web_comments_controller.dispatch(comments, action$6);
        }), t.comments);
      case /* Invitations */ 48 :
        const action$7 = action._0;
        return Stdlib__Option.iter((function (c) {
          Mapre_web__Web_invitation_controller.dispatch(c, action$7);
        }), t.invitations);
      default:
        return Curry._1(t.emit, action);
    }
  }
}

function panel_action(t, action) {
  if (/* tag */ typeof action !== "object" && typeof action !== "function") {
    return session_action(t, action);
  }
  switch (action.TAG) {
    case /* Graph */ 36 :
      const action$1 = action._0;
      return Stdlib__Option.iter((function (graph) {
        Mapre_web__Web_graph_controller.dispatch(graph, action$1);
      }), t.graph);
    case /* Settings */ 37 :
      const action$2 = action._0;
      if (/* tag */ typeof action$2 !== "object" && typeof action$2 !== "function" && action$2 === /* Close */ 0) {
        Stdlib__Option.iter((function (tokens) {
          Mapre_web__Web_personal_tokens_controller.dispatch(tokens, /* Close */ 0);
        }), t.personal_tokens);
        return Stdlib__Option.iter((function (settings) {
          Mapre_web__Web_settings_controller.dispatch(settings, /* Close */ 0);
        }), t.settings);
      }
      return Stdlib__Option.iter((function (settings) {
        Mapre_web__Web_settings_controller.dispatch(settings, action$2);
      }), t.settings);
    case /* Usage */ 38 :
      const action$3 = action._0;
      return Stdlib__Option.iter((function (usage) {
        Mapre_web__Web_usage_controller.dispatch(usage, action$3);
      }), t.usage);
    case /* Session_usage */ 39 :
      const action$4 = action._0;
      return Stdlib__Option.iter((function (controller) {
        Mapre_web__Web_session_usage_controller.dispatch(controller, action$4);
      }), t.session_usage);
    case /* Personal_tokens */ 40 :
      const action$5 = action._0;
      return Stdlib__Option.iter((function (tokens) {
        Mapre_web__Web_personal_tokens_controller.dispatch(tokens, action$5);
      }), t.personal_tokens);
    case /* Accounts */ 41 :
      const action$6 = action._0;
      return Stdlib__Option.iter((function (accounts) {
        Mapre_web__Web_accounts_controller.dispatch(accounts, action$6);
      }), t.accounts);
    default:
      return session_action(t, action);
  }
}

function dispatch(t, action) {
  let exit = 0;
  if (/* tag */ typeof action !== "object" && typeof action !== "function") {
    switch (action) {
      case /* Close_session_panel */ 16 :
      case /* Close_settings */ 17 :
      case /* Escape */ 18 :
        Stdlib__Option.iter(Mapre_web__Web_session_usage_controller.cancel, t.session_usage);
        break;
      default:
        exit = 1;
    }
  } else if (action.TAG === /* Open_session_panel */ 51) {
    Stdlib__Option.iter(Mapre_web__Web_session_usage_controller.cancel, t.session_usage);
  } else {
    exit = 1;
  }
  if (exit === 1) {
    if (Mapre_web__Web_model.pane_opened(action)) {
      Stdlib__Option.iter(Mapre_web__Web_session_usage_controller.cancel, t.session_usage);
    }
    
  }
  if (/* tag */ typeof action !== "object" && typeof action !== "function") {
    switch (action) {
      case /* Refresh_subscriptions */ 0 :
        return subscriptions(t, false);
      case /* More_subscriptions */ 1 :
        if (Curry._1(t.model, undefined).subscription_cursor !== undefined && !Curry._1(t.model, undefined).subscriptions_loading) {
          return subscriptions(t, true);
        } else {
          return;
        }
      case /* Load_older */ 2 :
        const model = Curry._1(t.model, undefined);
        const match = Mapre_web__Web_types.workspace(model.route);
        const match$1 = Mapre_web__Web_types.session(model.route);
        const match$2 = model.backlog.before;
        if (match !== undefined && match$1 !== undefined && match$2 !== undefined && model.backlog.more && !model.backlog.loading) {
          Curry._1(t.emit, {
            TAG: /* Older_loading */ 12,
            _0: true
          });
          return request(t, undefined, (function (error) {
            Curry._1(t.emit, {
              TAG: /* Older_loading */ 12,
              _0: false
            });
            failure(t, error);
          }), session_path(match, match$1) + ("/events?mode=recent&limit=100&before_seq=" + String(match$2)), (function (json) {
            const match = recent_page(json);
            Curry._1(t.emit, {
              TAG: /* Older */ 11,
              _0: match[1],
              _1: match[2],
              _2: match[3]
            });
          }));
        } else {
          return;
        }
      case /* Submit */ 4 :
        const model$1 = Curry._1(t.model, undefined);
        const match$3 = model$1.form;
        const match$4 = Mapre_web__Web_types.workspace(model$1.route);
        const match$5 = Mapre_web__Web_types.project(model$1.route);
        if (match$3 === undefined) {
          return;
        }
        if (match$4 === undefined) {
          return;
        }
        if (match$5 === undefined) {
          return;
        }
        if (!Mapre_web__Web_model.can_submit(model$1)) {
          return;
        }
        const match$6 = budget(match$3.budget);
        const match$7 = Mapre_web__Web_deadline.parse(match$3.deadline);
        const match$8 = Stdlib__List.find_opt((function (project) {
          return project.id === match$5;
        }), model$1.projects);
        if (match$6 !== undefined && match$7 !== undefined) {
          if (match$8 === undefined) {
            return Curry._1(t.emit, {
              TAG: /* Notice */ 21,
              _0: "Enter a budget greater than zero and no more than 2147 USD."
            });
          }
          if (match$3.subscription === undefined) {
            return Curry._1(t.emit, {
              TAG: /* Notice */ 21,
              _0: "Enter a budget greater than zero and no more than 2147 USD."
            });
          }
          const subscription = Stdlib__Option.get(match$3.subscription);
          const match$9 = Stdlib__Option.get(form_source(model$1, match$3));
          Curry._1(t.emit, /* Pending */ 5);
          const body = JSON.stringify(Js__Js_dict.fromList(Stdlib.$at({
            hd: [
              "request_id",
              Mapre_wire__Json.str(match$3.request_id)
            ],
            tl: {
              hd: [
                "title",
                Mapre_wire__Json.str(match$3.title)
              ],
              tl: {
                hd: [
                  "prompt",
                  Mapre_wire__Json.str(match$3.prompt)
                ],
                tl: {
                  hd: [
                    "snapshot_id",
                    Mapre_wire__Json.str(match$9[0])
                  ],
                  tl: {
                    hd: [
                      "parent_id",
                      match$9[1]
                    ],
                    tl: {
                      hd: [
                        "expected_project_version",
                        match$8.version
                      ],
                      tl: {
                        hd: [
                          "budget_microusd",
                          match$6
                        ],
                        tl: {
                          hd: [
                            "deadline_at",
                            Stdlib__Option.fold(null, (function (prim) {
                              return prim;
                            }), Caml_option.valFromOption(match$7))
                          ],
                          tl: {
                            hd: [
                              "connection_id",
                              Mapre_wire__Json.str(subscription.id)
                            ],
                            tl: {
                              hd: [
                                "expected_connection_version",
                                subscription.authorization_version
                              ],
                              tl: /* [] */ 0
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }, Mapre_web__Web_attachments_model.fields(Mapre_web__Web_attachments_model.references(match$3.attachments)))));
          return request(t, body, (function (param) {
            if (/* tag */ typeof param !== "object" && typeof param !== "function" || !(param.TAG === /* Missing */ 0 && param._0 === "connection_not_found")) {
              return failure(t, param);
            } else {
              return Curry._1(t.emit, {
                TAG: /* Notice */ 21,
                _0: "Selected subscription is no longer available. Refresh subscriptions and choose an account."
              });
            }
          }), project_path(match$4, match$5) + "/sessions", (function (json) {
            const accepted = Mapre_web__Web_codec.session(Mapre_wire__Json.get(json, "session"));
            navigate(t, undefined, {
              TAG: /* Session */ 3,
              _0: match$4,
              _1: match$5,
              _2: accepted.id
            });
          }));
        }
        if (match$7 !== undefined) {
          return Curry._1(t.emit, {
            TAG: /* Notice */ 21,
            _0: "Enter a budget greater than zero and no more than 2147 USD."
          });
        } else {
          return Curry._1(t.emit, {
            TAG: /* Notice */ 21,
            _0: "Enter a UTC timestamp within the next twelve hours, or leave the end time blank."
          });
        }
      case /* Retry_loading */ 6 :
        return navigate(t, false, Curry._1(t.model, undefined).route);
      case /* Logout */ 8 :
        stop(t);
        return request(t, "{}", undefined, "/auth/logout", (function (param) {
          lock(t, /* Login_required */ 0, "Sign in required");
        }));
      case /* More_sessions */ 9 :
        const match$10 = Curry._1(t.model, undefined).route;
        if (/* tag */ typeof match$10 !== "object" && typeof match$10 !== "function") {
          return;
        }
        switch (match$10.TAG) {
          case /* Project */ 2 :
          case /* Session */ 3 :
            break;
          default:
            return;
        }
        return list_sessions(t, match$10._0, match$10._1, true);
      case /* Create_workspace */ 11 :
        const model$2 = Curry._1(t.model, undefined);
        const form = model$2.workspace_form;
        if (form === undefined) {
          return;
        }
        if (!Mapre_web__Web_model.can_create_workspace(model$2)) {
          return;
        }
        Curry._1(t.emit, /* Workspace_pending */ 12);
        const body$1 = JSON.stringify(Js__Js_dict.fromList({
          hd: [
            "request_id",
            Mapre_wire__Json.str(form.request_id)
          ],
          tl: {
            hd: [
              "name",
              Mapre_wire__Json.str(form.name)
            ],
            tl: {
              hd: [
                "timezone",
                Mapre_wire__Json.str(form.timezone)
              ],
              tl: /* [] */ 0
            }
          }
        }));
        return request(t, body$1, undefined, "/api/workspaces", (function (json) {
          navigate(t, undefined, {
            TAG: /* Workspace */ 1,
            _0: Mapre_wire__Json.string(Mapre_wire__Json.get(json, "workspace"), "id")
          });
        }));
      default:
        return panel_action(t, action);
    }
  } else {
    switch (action.TAG) {
      case /* Navigate */ 0 :
        return navigate(t, undefined, action._0);
      case /* Open_form */ 15 :
        Curry._1(t.emit, {
          TAG: /* Open_form */ 15,
          _0: crypto.randomUUID()
        });
        return subscriptions(t, false);
      case /* Load_detail */ 24 :
        const match$11 = Curry._1(t.model, undefined);
        const match$12 = match$11.route;
        if (/* tag */ typeof match$12 !== "object" && typeof match$12 !== "function" || match$12.TAG !== /* Session */ 3) {
          return;
        } else {
          return request(t, undefined, undefined, session_path(match$12._0, match$12._2) + ("/events/" + String(action._0)), (function (json) {
            Curry._1(t.emit, {
              TAG: /* Detail */ 13,
              _0: Mapre_web__Web_codec.$$event(Mapre_wire__Json.get(json, "event"))
            });
          }));
        }
      case /* Open_workspace */ 29 :
        if (Curry._1(t.model, undefined).current_user !== undefined) {
          navigate(t, undefined, /* Home */ 0);
          return Curry._1(t.emit, {
            TAG: /* Open_workspace */ 29,
            _0: crypto.randomUUID()
          });
        } else {
          return;
        }
      case /* Project_setup */ 32 :
        const action$1 = action._0;
        return Stdlib__Option.iter((function (setup) {
          Mapre_web__Web_project_controller.dispatch(setup, action$1);
        }), t.project_setup);
      case /* Environment */ 33 :
        const action$2 = action._0;
        return Stdlib__Option.iter((function (editor) {
          Mapre_web__Web_environment_controller.dispatch(editor, action$2);
        }), t.environment);
      case /* Build */ 34 :
        const action$3 = action._0;
        return Stdlib__Option.iter((function (builds) {
          Mapre_web__Web_build_controller.dispatch(builds, action$3);
        }), t.builds);
      case /* Pulls */ 35 :
        const action$4 = action._0;
        return Stdlib__Option.iter((function (pulls) {
          Mapre_web__Web_pulls_controller.dispatch(pulls, action$4);
        }), t.pulls);
      default:
        return panel_action(t, action);
    }
  }
}

function connect_controllers(t) {
  t.session_usage = Caml_option.some(Mapre_web__Web_session_usage_controller.create(t.emit, t.model, (function (param) {
    return failure(t, param);
  })));
  t.usage = Caml_option.some(Mapre_web__Web_usage_controller.create(t.emit, t.model, (function (param) {
    return failure(t, param);
  })));
  t.invitations = Caml_option.some(Mapre_web__Web_invitation_controller.create(t.emit, t.model, (function (param) {
    return failure(t, param);
  }), (function (eta) {
    navigate(t, undefined, eta);
  })));
  t.project_setup = Caml_option.some(Mapre_web__Web_project_controller.create(t.emit, t.model, (function (param) {
    return failure(t, param);
  }), (function (eta) {
    navigate(t, undefined, eta);
  })));
  t.environment = Caml_option.some(Mapre_web__Web_environment_controller.create(t.emit, t.model, (function (param) {
    return failure(t, param);
  })));
  t.builds = Caml_option.some(Mapre_web__Web_build_controller.create(t.emit, t.model, (function (param) {
    return failure(t, param);
  })));
  t.pulls = Caml_option.some(Mapre_web__Web_pulls_controller.create(t.emit, t.model, (function (param) {
    return failure(t, param);
  })));
  t.settings = Caml_option.some(Mapre_web__Web_settings_controller.create(t.emit, t.model, (function (param) {
    return failure(t, param);
  })));
  t.personal_tokens = Caml_option.some(Mapre_web__Web_personal_tokens_controller.create(t.emit, t.model, (function (param) {
    return failure(t, param);
  })));
  t.graph = Caml_option.some(Mapre_web__Web_graph_controller.create(t.emit, t.model, (function (param) {
    return failure(t, param);
  })));
  t.accounts = Caml_option.some(Mapre_web__Web_accounts_controller.create(t.emit, t.model, (function (param) {
    return failure(t, param);
  }), (function (param) {
    subscriptions(t, false);
  })));
  t.permissions = Caml_option.some(Mapre_web__Web_permissions_controller.create(t.emit, t.model, (function (param) {
    return failure(t, param);
  })));
  t.messages = Caml_option.some(Mapre_web__Web_message_controller.create(t.emit, t.model, (function (param) {
    return failure(t, param);
  }), (function (param) {
    subscriptions(t, false);
  })));
  t.attachments = Caml_option.some(Mapre_web__Web_attachments_controller.create(t.emit, t.model, (function (param) {
    return failure(t, param);
  })));
  t.checkpoint = Caml_option.some(Mapre_web__Web_checkpoint_controller.create(t.emit, t.model, (function (param) {
    return failure(t, param);
  })));
  t.comments = Caml_option.some(Mapre_web__Web_comments_controller.create(t.emit, t.model, (function (param) {
    return failure(t, param);
  })));
  t.publication = Caml_option.some(Mapre_web__Web_publication_controller.create(t.emit, t.model, (function (param) {
    return failure(t, param);
  })));
}

function create(emit, model) {
  const t = {
    emit,
    model,
    generation: 0,
    controller: new AbortController(),
    stream: undefined,
    stopped: false,
    poll: undefined,
    control_notice: undefined,
    project_setup: undefined,
    environment: undefined,
    builds: undefined,
    pulls: undefined,
    graph: undefined,
    settings: undefined,
    usage: undefined,
    session_usage: undefined,
    personal_tokens: undefined,
    accounts: undefined,
    permissions: undefined,
    messages: undefined,
    attachments: undefined,
    publication: undefined,
    checkpoint: undefined,
    comments: undefined,
    invitations: undefined
  };
  connect_controllers(t);
  Mapre_web__Browser.listen("popstate", (function (param) {
    if (!t.stopped) {
      return navigate(t, false, Mapre_web__Web_types.route(Mapre_web__Browser.pathname()));
    }
    
  }));
  Mapre_web__Browser.listen("online", (function (param) {
    if (!t.stopped) {
      return Stdlib__Option.iter(Mapre_web__Web_connection.reconnect, t.stream);
    }
    
  }));
  Mapre_web__Browser.listen("pagehide", (function (param) {
    dispose(t);
  }));
  Mapre_web__Browser.listen("pageshow", (function (param) {
    if (t.stopped) {
      t.stopped = false;
      return navigate(t, false, Mapre_web__Web_types.route(Mapre_web__Browser.pathname()));
    }
    
  }));
  Mapre_web__Browser.listen("resize", (function (param) {
    if (!t.stopped) {
      return Curry._1(t.emit, {
        TAG: /* Compact */ 25,
        _0: Mapre_web__Browser.compact()
      });
    }
    
  }));
  Mapre_web__Browser.on_escape(function (param) {
    if (!t.stopped) {
      return Curry._1(t.emit, /* Escape */ 18);
    }
    
  });
  Curry._1(t.emit, {
    TAG: /* Compact */ 25,
    _0: Mapre_web__Browser.compact()
  });
  navigate(t, false, Mapre_web__Web_types.route(Mapre_web__Browser.pathname()));
  return t;
}

export {
  create,
  dispatch,
  dispose,
}
/* Mapre_web__Browser Not a pure module */
